const settleFestivalLiveMapLoading = () => {
    document.querySelectorAll('[data-festival-live-map]').forEach((mapElement) => {
        const loadingElement = mapElement.querySelector(
            '[data-festival-live-map-loading]'
        );

        if (! loadingElement) {
            return;
        }

        const errorElement = mapElement.querySelector(
            '[data-festival-live-map-error]'
        );

        const canvas = mapElement.querySelector(
            '[data-festival-live-map-canvas]'
        );

        const finishLoading = () => {
            if (! loadingElement.isConnected) {
                return;
            }

            loadingElement.remove();
        };

        // Leaflet creates its container synchronously before the asynchronous
        // live-location request begins. Once that container exists, expose the
        // base festival map immediately instead of letting a member-location
        // or illustrated-map failure cover it with an endless spinner.
        if (canvas?.querySelector('.leaflet-container, .leaflet-pane')) {
            finishLoading();
            return;
        }

        const observer = new MutationObserver(() => {
            if (
                canvas?.querySelector('.leaflet-container, .leaflet-pane')
                || (
                    errorElement
                    && ! errorElement.classList.contains('hidden')
                )
            ) {
                finishLoading();
                observer.disconnect();
            }
        });

        if (canvas) {
            observer.observe(canvas, {
                childList: true,
                subtree: true,
            });
        }

        if (errorElement) {
            observer.observe(errorElement, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }

        window.setTimeout(() => {
            if (! loadingElement.isConnected) {
                observer.disconnect();
                return;
            }

            finishLoading();
            observer.disconnect();

            if (
                errorElement
                && errorElement.classList.contains('hidden')
            ) {
                errorElement.textContent =
                    'The live member-location layer is taking longer than expected. The festival map is still available; use Refresh to try the live layer again.';
                errorElement.classList.remove('hidden');
            }
        }, 8000);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        settleFestivalLiveMapLoading,
        { once: true }
    );
} else {
    settleFestivalLiveMapLoading();
}

document.addEventListener(
    'livewire:navigated',
    settleFestivalLiveMapLoading
);
